import React, { Fragment, useEffect, useRef, useState } from 'react'
import AddComponent from '../../../components/AddComponent'
import { ArrowsUpDownIcon, DocumentArrowUpIcon, DocumentIcon, PencilSquareIcon, PlusCircleIcon, TableCellsIcon, TrashIcon } from '@heroicons/react/24/solid'
import LinkButton from '../../helpers/LinkButton'
import Table from '../../helpers/Table'
import Loader from '../../Common/Loader'
import axiosClient from '../../../Encapsulation/Axios'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import flasher from '@flasher/flasher'
import ActionButton from '../../helpers/ActionButton'
import { useReactToPrint } from 'react-to-print'
import Pagination from '../../helpers/Pagination';
import { AddCircle } from 'iconsax-react'
import DataNotFound from '../../helpers/DataNotFound'
import { GetHotelGuestCheckOutList } from '../../../Encapsulation/HotelDomainEntities/HotelGuestCheckOut'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

function CheckOut() {
    document.title = 'Gladiance - Check Out'
    const tableHeading = ['Sr.No', 'Room No', 'Name', 'Check In Date', 'Check In Time', 'Check Out Date', 'Check Out Time', 'Email', 'Mobile', 'Action'];
    const [loader, setLoader] = useState(false)
    const [viewModel, setViewModel] = useState(false)
    const [checkOutCsv, setCheckOutCsv] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 7;
    const [checkOutList, setCheckOutList] = useState([])

    const fetchCheckOutList = async () => {
        setCheckOutList(await GetHotelGuestCheckOutList());
    }

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const headers = [
        { label: 'Sr.No', key: 'index' },
        { label: 'Material', key: 'material_name' },
        { label: 'Unit', key: 'material_unit' },
    ];

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const handleCheckOutCsv = () => {
        // setLoader(true)
        // const formData = new FormData()
        // formData.append('checkOutCsv', checkOutCsv)
        // axiosClient.post(`import_material`, formData)
        //     .then(({ data }) => {
        //         flasher.success(data.msg)
        //         setLoader(false)
        //     })
        //     .catch(({ response }) => {
        //         setLoader(false)
        //     })
        // setViewModel(false)
        // fetchCheckOutList()
    }

    const deleteCheckOut = (id) => {
        // Swal.fire({
        //     title: 'Are you sure to delete this?',
        //     text: "You won't be able to revert this!",
        //     icon: 'warning',
        //     showCancelButton: true,
        //     confirmButtonColor: '#3085d6',
        //     cancelButtonColor: '#d33',
        //     confirmButtonText: 'Yes, delete it!'
        // }).then((result) => {
        //     if (result.isConfirmed) {
        //         axiosClient.delete(`/delete_material/${id}`)
        //             .then(({ data }) => {
        //                 flasher.success(data.msg)
        //                 fetchCheckOutList()
        //             })
        //     }
        // })
    }
    useEffect(() => {
        fetchCheckOutList()
    }, [])

    return (
        <Fragment>
            {loader ? (<Loader />) : (
                <AddComponent title={'Check Outs'} button={
                    <LinkButton to={'/check-out/add-check-out'}>
                        <AddCircle variant='Bold' className='w-5 h-5' />
                        <span>Add Check Out</span>
                    </LinkButton>
                }>
                    {checkOutList && checkOutList.length > 0 ? (
                        <div ref={componentRef} className='m-2'>
                            <Table tableHeading={tableHeading} >
                                {checkOutList.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((tableData, tableDataID) => {
                                    return (
                                        <Fragment key={tableDataID}>
                                            {/* <tr className="">
                                                <td className="px-4 py-3 border-b border-opacity-30 border-white text-center">{1}</td>
                                                <td className="px-4 py-3 border-b border-opacity-30 border-white text-center">{'Mr. Jeevan Tripathi'}</td>
                                                <td className="px-4 py-3 border-b border-opacity-30 border-white text-center"> {'1/2/23'}</td>
                                                <td className="px-4 py-3 border-b border-opacity-30 border-white text-center">{'12:00 PM'}</td>
                                                <td className="px-4 py-3 border-b border-opacity-30 border-white text-center">{'3/2/23'}</td>
                                                <td className="px-4 py-3 border-b border-opacity-30 border-white text-center">{'12:00 PM'}</td>
                                                <td className="px-4 py-3 border-b border-opacity-30 border-white text-center">{'jee@gmail.com'}</td>
                                                <td className="px-4 py-3 border-b border-opacity-30 border-white text-center">{'9123400123'}</td>
                                                <td rowSpan={2} className="px-4 py-3">{'Send Gladiance One link(non functional) with temporary user rights and room type specific data.'}</td>
                                            </tr> */}
                                            <tr className="border-b border-opacity-30 border-white text-center">
                                                <td className="px-4 py-3">{tableDataID + 1}</td>
                                                <td className="px-4 py-3">{tableData}</td>
                                                <td className="px-4 py-3">{tableData}</td>
                                                <td className="px-4 py-3">{tableData}</td>
                                                <td className="px-4 py-3">{tableData}</td>
                                                <td className="px-4 py-3">{tableData}</td>
                                                <td className="px-4 py-3">{tableData}</td>
                                                <td className="px-4 py-3">{tableData}</td>
                                            </tr>
                                        </Fragment>
                                    )
                                })}
                                {/* <tr className="border-b border-opacity-30 border-white text-center">
                                    <td className="px-4 py-3">{1}</td>
                                    <td className="px-4 py-3 ">{'Jacket'} </td>
                                    <td className="px-4 py-3 "> </td>
                                    <td className="px-4 py-3">{'300'}</td>
                                    <td className="px-4 py-3">{'200'}</td>
                                    <td className="px-4 py-3">
                                        <div className='flex justify-center gap-3'>
                                            <Link title='Edit'><ActionButton className={'p-1.5 text-white bg-yellow-400 '}>
                                                <PencilSquareIcon className='w-4 h-4' />
                                            </ActionButton></Link>
                                            <ActionButton onClick={() => deleteLaundry('tableData.id')} title={'Delete'} className='p-1.5 text-white bg-red-600 rounded-lg cursor-pointer'>
                                                <TrashIcon className='w-4 h-4' />
                                            </ActionButton>
                                        </div>
                                    </td>
                                </tr> */}
                            </Table>
                        </div>

                    ) : (                        
                         <DataNotFound labelText={'Sorry! Check Out Data Not Found'} />
                    )}
                    {checkOutList && checkOutList.length > 7 ? (<div className="flex justify-end">
                        <Pagination
                            itemsPerPage={itemsPerPage}
                            totalItems={checkOutList.length}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                        />
                    </div>) : (<div></div>)
                    }

                </AddComponent>
            )}
        </Fragment>
    )
}

export default CheckOut
